import { render, staticRenderFns } from "./OrdenEdit.vue?vue&type=template&id=6084a7fa&scoped=true&"
import script from "./OrdenEdit.vue?vue&type=script&lang=js&"
export * from "./OrdenEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6084a7fa",
  null
  
)

export default component.exports